// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#mail-content[data-v-e2ae2bf0]{margin-left:30px;margin-top:2px;display:flex;flex-direction:column;height:100%}#mail-message-has-blocked-content[data-v-e2ae2bf0]{margin-left:8px}#message-container[data-v-e2ae2bf0]{flex:1}#message-frame[data-v-e2ae2bf0]{height:100%}\n", ""]);
// Exports
module.exports = exports;
